export default "__VITE_ASSET__BzClXvlZ__"